module.exports = __webpack_public_path__ + "static/media/usdtzLogo.5bf8a98e.png";